(function () {
  function initMinQty(scope) {
    const root = scope || document;

    const productForms = root.querySelectorAll('product-form[data-min-qty]');

    productForms.forEach((pf) => {
      const minQty = parseInt(pf.getAttribute('data-min-qty') || '1', 10);
      if (!Number.isFinite(minQty) || minQty <= 1) return;

      // 1) Hitta add-to-cart-formen (den ligger inne i product-form)
      const innerForm = pf.querySelector('form');
      if (!innerForm) return;

      const formId = innerForm.getAttribute('id');

      // 2) Hitta quantity input:
      // - Den kan ligga utanför product-form i Dawn
      // - Då är den ofta kopplad via form="FORM_ID"
      let qtyInput = null;

      if (formId) {
        qtyInput = root.querySelector(`input[name="quantity"][form="${CSS.escape(formId)}"]`);
      }

      // fallback: leta närmast i samma produktcontainer
      if (!qtyInput) {
        const container =
          pf.closest('.product__info-container') ||
          pf.closest('.product__info-wrapper') ||
          document;
        qtyInput = container.querySelector('input[name="quantity"]');
      }

      if (!qtyInput) return;

      // Sätt min-attribut
      qtyInput.setAttribute('min', String(minQty));

      // Om den står på 1 → bumpa till minQty
      const current = parseInt(qtyInput.value || '1', 10);
      if (!Number.isFinite(current) || current < minQty) {
        qtyInput.value = String(minQty);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Säkerhet: stoppa submit om någon ändå lyckas få < min
      innerForm.addEventListener('submit', (e) => {
        const val = parseInt(qtyInput.value || '1', 10);
        if (!Number.isFinite(val) || val < minQty) {
          e.preventDefault();
          qtyInput.value = String(minQty);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.focus();
          alert(`Minsta antal för den här produkten är ${minQty} st.`);
        }
      });
    });
  }

  function initCartMinQty(scope) {
    const root = scope || document;

    const cartItems = root.querySelectorAll('tr.cart-item[data-min-qty], .cart-item[data-min-qty]');

    cartItems.forEach((row) => {
      const minQty = parseInt(row.getAttribute('data-min-qty') || '1', 10);
      if (!Number.isFinite(minQty) || minQty <= 1) return;

      // Dawn cart använder nästan alltid updates[]
      const qtyInput = row.querySelector('input[name="updates[]"], input[name="quantity"]');
      if (!qtyInput) return;

      qtyInput.setAttribute('min', String(minQty));

      const current = parseInt(qtyInput.value || '1', 10);
      if (!Number.isFinite(current) || current < minQty) {
        qtyInput.value = String(minQty);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value || '1', 10);
        if (!Number.isFinite(val) || val < minQty) {
          qtyInput.value = String(minQty);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMinQty(document);
    initCartMinQty(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initMinQty(event.target);
    initCartMinQty(event.target);
  });
})();
